import { logger as Logger } from '@kibt/krn-utils';
import { currentCountry } from '@/common/const';
import { getCookie } from '@/common/cookie';
// import { isProduction } from '@/common/env';
// import { KDS_APP_LOG_TYPE } from '@env';
import { validateP0Log } from './utils/recoLog';

type NetworkType = 'unknown' | 'none' | 'wifi' | '4g' | '3g' | '2g' | undefined;
const radarConf = {
    // 雷达平台上的唯一标识
    projectId: 'cfb09b178a',
    // 上报采样率，1 为全部上报
    sampling: 1,
};
// krn环境读取是固定的值，去掉从.env读取逻辑
const KDS_APP_LOG_TYPE = 'oversea';
const isProduction = true;
console.log('KDS_APP_LOG_TYPE::::', KDS_APP_LOG_TYPE, isProduction);
// WebLogger内核SDK配置参数
const logConfig = {
    env: KDS_APP_LOG_TYPE || 'development',
    proto: 'v3',
    autoPV: false,
    fps: false,
    logger: !isProduction,
    radar: radarConf,
    plugins: [],
};
const kpn = getCookie('kpn') || 'KWAI';

export const bucket = getCookie('bucket') || 'UNKNOWN';

// 公参配置
const baseOptions = {
    product_name: kpn,
    package_name: kpn,
    // user_id: userId,
    h5_extra_attr: {
        county_name: {
            country: ['BR', 'BRA'].includes(currentCountry) ? 'BRA' : currentCountry?.toUpperCase() || 'UNKNOWN',
            bucket: getCookie('bucket') || 'UNKNOWN',
        },
    },
};

/**
 * 只能初始化之后调用，即运行时调用，组件渲染后
 */
export let webLogger: Logger;
let _autoPv;

// export let radar;
export const initWebLogger = (
    props: any = {},
    config: {
        navigation?: any;
        pageMap?: any;
    } = {},
) => {
    const { componentName, bundleId } = props;
    const autoPvConfig = {
        // navigation, // 非必填 使用 react-navigation 需要传入 navigation Ref
        // pageMap: autoPvPageMap, // 每次 autoPv 上报埋点时都会先经过 pageMap，可在这里选择是否过滤掉埋点，返回 false 则不上报
        ...config,
        componentName: componentName, // 必填
        bundleId: bundleId, // 必填
        coPage: false, // 非必填 ,半屏为true
        debug: true, // 非必填，打印打点信息
    };

    const options: any = {
        baseOptions,
        logConfig,
        ...props,
    };

    // 如果没有传pageMap，说明是异步PV， 异步PV初始化Weblogger不需要传autoPvConfig
    if (config.pageMap) {
        options.autoPvConfig = autoPvConfig;
    }

    // 初始化weblogger
    const logInstance = new Logger(options);
    webLogger = logInstance;

    // // 初始化AutoPv
    // _autoPv = new AutoPV({
    //     navigation: config.navigation,
    //     componentName,
    //     bundleId,
    //     asyncParams: true,
    //     debug: true,
    // });
    // logInstance.webLogger.addPluginInstance(_autoPv);
};

/**
 * log埋点增加全局的版本号，排查故障的时候可以统一
 */
const commonParames = {
    codeVersion: 'v3',
    container: 'rn',
};

export const radar = {
    event(args: { name: string; eventType?: string; params?: object }) {
        const { name, eventType = 'SHOP_KRN_CUSTOM_EVENT', params = {} } = args || {};
        webLogger?.webLogger?.plugins?.radar?.event({
            name,
            eventName: name,
            eventType,
            event_type: eventType,
            extra: {
                ...commonParames,
                ...params,
            },
            extra_info: {
                ...commonParames,
                ...params,
            },
            // params: {
            //     ...commonParames,
            //     ...params,
            // },
        });
    },
};

export interface PageMapParams {
    page: string;
    params?: {
        [key: string]: any;
    };
    contentPackage?: {
        [key: string]: any;
    };
    feedLogCtx?: {
        [key: string]: any;
    };
}

export interface KRNAutoPVConfig {
    navigation?: any;
    bundleId: string;
    componentName: string;
    coPage?: boolean;
    debug?: boolean;
    pageMap: ({ page, params }: PageMapParams) => PageMapParams;
}

export const logger = {
    sendClick(args: {
        // 页面动作标识
        action: string;
        // 额外参数
        params?: object;
        isSendRadar?: boolean;
        // 自定义雷达event的名字
        radarName?: string;
    }) {
        const { action, isSendRadar = true, params = {}, radarName = action } = args;
        webLogger.sendLog({
            type: 'click',
            name: action,
            value: { ...params, ...commonParames },
        });
        if (isSendRadar) {
            radar.event({ name: radarName, eventType: 'SHOP_KRN_CUSTOM_CLICK', params });
        }
        // 校验p0埋点的合法性
        validateP0Log({ action, params });
    },
    sendShow(args: {
        // 页面动作标识
        action: string;
        // 额外参数
        params?: object;
        isSendRadar?: boolean;
        // 自定义雷达event的名字
        radarName?: string;
    }) {
        const { action, isSendRadar = true, params = {}, radarName = action } = args;
        webLogger.sendLog({
            type: 'show',
            name: action,
            value: { ...params, ...commonParames },
        });
        if (isSendRadar) {
            radar.event({ name: radarName, eventType: 'SHOP_KRN_CUSTOM_SHOW', params });
        }
        // 校验p0埋点的合法性
        validateP0Log({ action, params });
    },
    sendAsyncPV(options: {
        bundleId: string;
        componentName: string;
        pageMap: () => {
            page: string;
            params?: object;
        };
    }) {
        const { componentName, pageMap } = options;
        const { page, params = {} } = pageMap();
        // _autoPv?.sendPV?.({
        //     type: 'enter',
        //     page,
        //     params,
        // });
        // _autoPv.setAsyncParams(componentName, () => {
        //     return {
        //         page,
        //         params,
        //     };
        // });
    },
};
